import {ReactElement, ReactNode} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {Navigate} from 'react-router-dom';
import {useAppDispatch} from "lib/redux/hooks";
import {loginActions} from "./loginSlice";
import {authSelectors} from "./authSlice";
import {choseCustomerActions} from "./choseCustomerSlice";

interface RequireAuthProps {
    children: ReactNode
}

export function RequireAuth(props: RequireAuthProps): ReactElement {
    const loggedIn = useSelector(authSelectors.loggedIn);
    const customer = useSelector(authSelectors.customer);
    const location = useLocation();
    const dispatch = useAppDispatch();

    if (!loggedIn) {
        dispatch(loginActions.setTo(location));
        return <Navigate to="/login"/>
    }

    if (customer == null) {
        dispatch(choseCustomerActions.setTo(location));
        return <Navigate to="/login/customer"/>
    }

    return <>{props.children}</>;
}